class Utils {
  isMouse(mouseX, mouseY) {
    this.mouseX = mouseX;
    this.mouseY = mouseY;
    return this;
  }

  is(x, y) {
    return this.isMouse(x, y);
  }

  in() {
    let args = arguments;

    let _x, _y, _w, _h;

    if (args.length === 1) {
      let { x, y, width, height } = args[0];
      _x = x;
      _y = y;
      _w = width;
      _h = height;
    } else {
      _x = args[0];
      _y = args[1];
      _w = args[2];
      _h = args[3];
    }

    const mx = this.mouseX,
      my = this.mouseY;
    return _x <= mx && mx <= _x + _w && (_y <= my && my <= _y + _h);
  }

  /**
   * get computed style for an element, excluding any default styles
   *
   * @param {DOM} element
   * @return {object} difference
   */

  getStylesWithoutDefaults(element) {
    // creating an empty dummy object to compare with

    var defaultStyles = this.getDefaultStyles();
    var elementStyles = getComputedStyle(element);

    // calculating the difference
    var diff = {};
    for (var key in elementStyles) {
      if (
        elementStyles.hasOwnProperty(key) &&
        defaultStyles[key] !== elementStyles[key]
      ) {
        diff[key] = elementStyles[key];
      }
    }

    return diff;
  }

  getStringWidth(str) {
    // var dummy = document.createElement("element-" + new Date().getTime());
    // dummy.style.fontFamily = "Lato";
    // dummy.style.fontSize = "0.9em";
    // dummy.style.fontWeight = "lighter";
    // dummy.style.textAlign = "right";
    // document.body.appendChild(dummy);
    // dummy.innerText = str;
    //
    // const w = dummy.getBoundingClientRect();
    //
    // dummy.remove();
    //
    // return w.width;
    return this.getWidthOfText(str, "Lato", "15px");
  }

  getDefaultStyles() {
    var dummy = document.createElement("element-" + new Date().getTime());
    document.body.appendChild(dummy);

    // getting computed styles for both elements
    let styles = getComputedStyle(dummy);
    dummy.remove();
    return styles;
  }

  getWidthOfText(txt, fontname, fontsize) {
    if (this.getWidthOfText.c === undefined) {
      this.getWidthOfText.c = document.createElement("canvas");
      this.getWidthOfText.ctx = this.getWidthOfText.c.getContext("2d");
    }
    this.getWidthOfText.ctx.font = fontsize + " " + fontname;
    return this.getWidthOfText.ctx.measureText(txt).width;
  }
}

export default new Utils();



// WEBPACK FOOTER //
// ./src/utils/utils.js